import SingleInteractiveMaterialView from "@features/tools/view/interactive-materials-view/single-interactive-material-view";

const SingleInteractiveMaterials = () => {
  return <SingleInteractiveMaterialView />;
};

export default SingleInteractiveMaterials;
